/* eslint-disable react/self-closing-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTable, { ReactTableDefaults } from 'react-table-6';

import { FlexBar, FlexPadding, FlexItem } from '../base/styled';

import widgetWrapper from './widgetWrapper';

import { TableCellUtils } from './widgetUtils';

import './ReactTableWidget.scss';

class ReactTableWidget extends Component {

  static propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    defaultPage: PropTypes.number,
    defaultSortColumnId: PropTypes.string,
    defaultSortDirection: PropTypes.string,
    supportsDownloadCsv: PropTypes.bool,
    columns: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      Header: PropTypes.string,
      accessor: PropTypes.string,
      colType: PropTypes.string,
      posClass: PropTypes.string,
      negClass: PropTypes.string,
    })),
    cells: PropTypes.arrayOf(PropTypes.any),
  };

  static defaultProps = {
    title: '',
    subtitle: '',
    defaultPage: 1,
    defaultSortColumnId: null,
    defaultSortDirection: null,
    supportsDownloadCsv: true,
    columns: [],
    cells: [],
  };

  constructor(props) {
    super(props);
    // We need these because exportCSV() needs its own completely redundant row sorting implementation.
    // ReactTable provides sorting but provides no way to access the sorted values it's displaying
    this.sortColumnId = props.defaultSortColumnId;
    this.sortDirection = props.defaultSortDirection;
  }

  render() {

    const {
      title,
      subtitle,
      columns,
      cells,
      defaultPage,
      defaultSortColumnId,
      defaultSortDirection,
      supportsDownloadCsv,
    } = this.props;

    if (defaultSortColumnId && !this.sortColumnId) {
      this.sortColumnId = defaultSortColumnId;
    }
    if (defaultSortDirection && !this.defaultSortDirection) {
      this.sortDirection = defaultSortDirection;
    }

    const exportCSV = () => {
      const processedColumns = this.props.columns.map(TableCellUtils.processColumn);
      let lineValues = [];
      const allLineValues = [];
      this.props.cells.forEach((cell) => {
        lineValues = this.props.columns
          .map(c => c.field)
          .map(fieldName => ((cell[fieldName] === null || cell[fieldName] === undefined) ? '-' : cell[fieldName]));
        allLineValues.push(lineValues);
      });
      if (this.sortColumnId) {

        let sortMethod = (a, b, _desc) => (_desc ? a < b : a > b);

        const matchingColumn = processedColumns.find(e => (e.id === this.sortColumnId));
        let matchingColumnIndex = -1;
        if (matchingColumn) {
          matchingColumnIndex = processedColumns.indexOf(matchingColumn);
          if (matchingColumn.sortMethod) {
            sortMethod = matchingColumn.sortMethod;
          }
          allLineValues.sort((lineA, lineB) => sortMethod(lineA[matchingColumnIndex], lineB[matchingColumnIndex], this.sortDescending));
        }
      }

      let lineString = '';
      const allLineStrings = [];

      allLineValues.forEach((values) => {
        lineString = this.props.columns
          .map((column, index) => TableCellUtils.generateCellContent(
            ((values[index] || (typeof values[index] === 'number')) ? values[index] : '-'),
            this.props.columns[index],
            false,
          ))
          .join(',');
        allLineStrings.push(lineString);
      });

      const output = (this.props.columns.map(c => c.Header).join(',') + '\n' + allLineStrings.join('\n'));

      const data = new Blob([output], { type: 'text/plain' });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(data);
      a.download = 'performance.csv';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };

    function EnhancedPaginationComponent(props) {
      return (
        <FlexBar>
          <FlexPadding>
            { React.createElement(ReactTableDefaults.PaginationComponent, props) }
          </FlexPadding>
          <FlexItem width="300px" style={{ flexGrow: 0 }}>
            <div className="extra-pagination">
              <button type="button" className="csv" onClick={() => { exportCSV(); }}>Download CSV</button>
            </div>
          </FlexItem>
        </FlexBar>
      );
    }

    const mapped = columns.map(TableCellUtils.processColumn);
    const outer = this;
    const csvSupport = supportsDownloadCsv;
    return (
      <div className="SortableTableWidget">
        <div className="header">
          <div className="title">{title}</div>
          <div className="subtitle">{subtitle}</div>
        </div>
        <ReactTable
          columns={mapped}
          data={cells}
          pageSizeOptions={[10, 15, 20, 25, 50, 100]}
          sowPaginationBottom
          showPageSizeOptions={false}
          defaultPageSize={20}
          defaultPage={defaultPage}
          onSortedChange={([newSorted], _column, _shiftKey) => {
            outer.sortColumnId = newSorted.id;
            outer.sortDescending = newSorted.desc;
          }}
          PaginationComponent={ csvSupport ? EnhancedPaginationComponent : ReactTableDefaults.PaginationComponent }
        />
      </div>
    );
  }
}

export default widgetWrapper(ReactTableWidget);
